import { Loading, SidebarNav } from "@/components";
import { PageLayout } from "@/components/layouts/PageLayout";
import { Separator } from "@/components/ui/separator";
import { userHomeQuery } from "@/services/queries";
import { Navigate, Outlet } from "@tanstack/react-router";
// import HeaderSection from "@/components/header/hello";

const User = () => {
    const { data: response, isLoading } = userHomeQuery();
    const data = response?.data;

    const userHasPendingSubscription = data?.show_resume_button;

    const renderUserName = (name?: string) => {
        return name ? `Hola ${name.split(" ")[0]}` : "Hola";
    };

    if (isLoading) {
        return (
            <PageLayout>
                <div className="pt-6">
                    <Loading message="Buscando tu información..." />
                </div>
            </PageLayout>
        );
    }

    // Redirecto to resume checkout if user has a pending subscription
    if (userHasPendingSubscription) {
        return (
            <Navigate to="/rcheckout" search={{ uid: data?.username } as any} />
        );
    }

    return (
        <PageLayout withCard={false}>
            <div className="pt-4 lg:pt-6">
                <div className="rounded-lg border bg-white/90 p-4 shadow-sm lg:bg-white">
                    <div className="flex flex-col gap-1 sm:flex-row sm:items-end sm:justify-between">
                        <div>
                            <p className="text-xs font-semibold uppercase tracking-wide text-primary">
                                Mi Maifud
                            </p>
                            <h2 className="text-2xl font-bold tracking-tight">
                                {renderUserName(data?.user_name)}
                            </h2>
                        </div>
                        <p className="text-sm text-muted-foreground">
                            Gestiona tu suscripción, compras y datos.
                        </p>
                    </div>
                </div>
                <Separator className="my-4 hidden lg:block" />
                <div className="flex flex-col gap-4 lg:flex-row lg:gap-8">
                    <aside className="lg:w-[260px] lg:shrink-0">
                        <SidebarNav />
                    </aside>
                    <main className="min-w-0 flex-1">
                        <Outlet />
                    </main>
                </div>
            </div>
        </PageLayout>
    );
};

export default User;
